import React from 'react';

export default function ServiceUserPOAModule({ serviceUser, onClose }) {
    const poaList = serviceUser.poa || [];

    const Field = ({ label, value }) => (
        <div style={{ marginBottom: '15px', minWidth: '200px', flex: '1' }}>
            <label style={{ display: 'block', fontSize: '12px', textTransform: 'uppercase', color: '#6b7280', marginBottom: '4px', fontWeight: 'bold' }}>{label}</label>
            <div style={{ fontSize: '15px', fontWeight: '500', color: '#111827' }}>{value || 'Not provided'}</div>
        </div>
    );

    return (
        <div style={styles.modalOverlay} onClick={onClose}>
            <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
                <div style={styles.modalHeader}>
                    <div>
                        <h2 style={{ margin: 0, fontSize: '20px', color: '#111827' }}>Power of Attorney</h2>
                        <p style={{ margin: '4px 0 0', color: '#6b7280', fontSize: '14px' }}>Legal representatives for {serviceUser.fullName}</p>
                    </div>
                    <button onClick={onClose} style={styles.closeBtn}>×</button>
                </div>
                
                <div style={styles.scrollArea}>
                    {poaList.length === 0 ? (
                        <div style={{ padding: '40px', textAlign: 'center', color: '#6b7280', backgroundColor: '#f9fafb', borderRadius: '8px', border: '1px dashed #d1d5db' }}>
                            <p style={{ margin: 0, fontSize: '15px' }}>No Power of Attorney records found.</p>
                        </div>
                    ) : (
                        poaList.map((poa, index) => (
                            <div key={index} style={styles.section}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', paddingBottom: '12px', borderBottom: '1px solid #e5e7eb' }}>
                                    <h3 style={{ margin: 0, fontSize: '16px', color: '#111827' }}>{poa.name}</h3>
                                    <span style={{ backgroundColor: '#eff6ff', color: '#1d4ed8', padding: '4px 12px', borderRadius: '9999px', fontSize: '12px', fontWeight: 'bold' }}>{poa.type}</span>
                                </div>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                                    <Field label="Contact Number" value={poa.phone} />
                                    <Field label="Email Address" value={poa.email} />
                                    <Field label="Relation" value={poa.relation} />
                                </div>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', marginTop: '16px' }}>
                                    <Field label="Address" value={poa.address} />
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
}

const styles = {
    modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 },
    modalContent: { backgroundColor: 'white', borderRadius: '12px', width: '90%', maxWidth: '700px', maxHeight: '90vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' },
    modalHeader: { padding: '24px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' },
    closeBtn: { background: 'none', border: 'none', fontSize: '24px', color: '#9ca3af', cursor: 'pointer', lineHeight: 1 },
    scrollArea: { padding: '24px', overflowY: 'auto' },
    section: { backgroundColor: '#f9fafb', borderRadius: '8px', padding: '20px', border: '1px solid #e5e7eb', marginBottom: '20px' }
};
